import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { arrayOf, object, string } from "prop-types";
import Class from "./class";

const Classes = ({ classes, title, text }) => {
  return (
    <section id="classes" className="bg-color-1 page-section text-center">
      <Container>
        <h2>{title}</h2>
        <hr className="small" />
        <p className="lead mb-5">{text}</p>
        <Row>
          {classes
            .sort((a, b) => a.order - b.order)
            .map((c, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Col sm={6} md={3} key={i}>
                <Class
                  day={c.day}
                  venue={c.venue}
                  street={c.street}
                  town={c.town}
                  postcode={c.postcode}
                  mapUrl={c.mapUrl}
                  lesson1={c.lesson1}
                  lesson2={c.lesson2}
                  lesson3={c.lesson3}
                  price={c.price}
                  info={c.info}
                />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

Classes.propTypes = {
  classes: arrayOf(object).isRequired,
  title: string.isRequired,
  text: string.isRequired
};

export default Classes;
